import { render, staticRenderFns } from "./ChangeAssociationModal.vue?vue&type=template&id=3a94ab60&scoped=true&"
import script from "./ChangeAssociationModal.vue?vue&type=script&lang=js&"
export * from "./ChangeAssociationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a94ab60",
  null
  
)

export default component.exports